import { render, staticRenderFns } from "./Roulet3.vue?vue&type=template&id=54bff7e4&scoped=true&"
import script from "./Roulet3.vue?vue&type=script&lang=js&"
export * from "./Roulet3.vue?vue&type=script&lang=js&"
import style0 from "./Roulet3.vue?vue&type=style&index=0&id=54bff7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bff7e4",
  null
  
)

export default component.exports